module.exports = {
  member_benefit: "会員になって特典をお楽しみください",
  btn_sign_up: "入会",
  copyright: "© 2021 AYANA HOTEL. ALL RIGHTS RESERVED",
  footer_link_guest: "Guest Services",
  footer_link_tos: "利用規約",
  footer_link_faq: "FAQ",
  footer_link_point_policies: "Point Policies",
  footer_link_privacy_policies: "個人情報保護方針",
};
